import { Box, Heading, Table, Tbody, Tr, Td, Text, useColorMode } from '@chakra-ui/react';

export const TopTable = (props) => {
    const { colorMode } = useColorMode();
    const { title, data, ...boxProps } = props;

    const backgroundColor = colorMode === 'light' ? 'gray.30' : 'gray.700';


    return (
        <Box bg={backgroundColor} rounded='10px' boxShadow="md" {...boxProps}>
            <Box
                px={{
                    base: '4',
                    md: '6',
                }}
                py={{
                    base: '5',
                    md: '6',
                }}
            >
                <Heading
                    size={{
                        base: 'lg',
                        md: 'lg',
                    }}
                    mb="4"
                >
                    {title}
                </Heading>
                <Table variant="simple">
                    <Tbody>
                        {Array.isArray(data) && data.map((item, index) => (
                            <Tr key={index}>
                                <Td><Text fontSize='2xl'>{item}</Text></Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Box>
        </Box>
    );
}
